/*
 * File: deliveryAddressStreetFilter.tsx
 * Project: papa-bear
 * -----
 * Last Modified: 30 Dec 2021 12:17:58 pm
 * -----
 * Copyright (c) 2021 Elegant Software Solutions All rights reserved.
 */

import { Space } from 'antd';
import { FancyInput } from 'components/atoms/FancyInput';
import React, { ChangeEvent, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setFilterStreet } from 'redux/salesOrder/ordersSlice';
import { useDebouncedCallback } from 'use-debounce';

/* ****************** Interfaces ****************** */
interface Props {
  isDisabled?: boolean;
}

export const DeliveryAddressStreetFilter = ({ isDisabled }: Props): JSX.Element => {
  const dispatch = useDispatch();

  /* ****************** Functions ****************** */
  // Handle delay of searching data
  const handleInputChange = useDebouncedCallback((ev: ChangeEvent<HTMLInputElement>) => {
    dispatch(setFilterStreet(ev.target.value));
  }, 500);

  useEffect(() => {
    return (): void => {
      dispatch(setFilterStreet(undefined));
    };
  }, [dispatch]);

  /* ****************** Render ****************** */
  return (
    <Space direction="vertical" size="small">
      <FancyInput onChange={handleInputChange} placeholder="Street" width={150} disabled={isDisabled} />
    </Space>
  );
};
